import { render } from "./left.drawer.vue?vue&type=template&id=54982bd1&scoped=true"
import script from "./left.drawer.vue?vue&type=script&lang=js"
export * from "./left.drawer.vue?vue&type=script&lang=js"

import "./left.drawer.vue?vue&type=style&index=0&id=54982bd1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54982bd1"]])

export default __exports__